// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RatingOverview_wrapper_1ldAt","header":"RatingOverview_header_B0_f3","transactionNum":"RatingOverview_transactionNum_8yyAL"};